import Head from 'next/head';
import PropTypes from 'prop-types';
import { NextSeo } from 'next-seo';
import { TRIAL_CLASSES } from '@constants/segment';
import Layout from '@layout/index';
import BatchesGroupClassesListing from '@cont/SeeAll/BatchesGroupClassesListing';
import setupInitialProps from '@utils/setupInitialProps';
import { fetchTopologyInfo } from '@actions/topologies';
import { fetchBatchesGroupTrailClasses } from '@actions/batchGroups';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const BatchGroupClasses = ({ goalInfo }) => {
  const { title } = goalInfo || {};
  const metaTitle = `Trial classes from batches | ${title} | Unacademy`;
  return (
    <>
      <NextSeo
        title={metaTitle}
        openGraph={{
          title: metaTitle
        }}
      />
      <Head>
        <title>{metaTitle}</title>
      </Head>
      <BatchesGroupClassesListing />
    </>
  );
};

BatchGroupClasses.pageInfo = {
  isMWebSupported: true,
  name: TRIAL_CLASSES,
  layoutOptions: {
    hideSearch: true,
    hideFooter: true
  }
};

export default BatchGroupClasses;

BatchGroupClasses.getInitialProps = setupInitialProps(
  async ({ store, query, isServer }) => {
    const { goalUID } = query;
    const promises = [];
    const state = store.getState();
    const key = `${goalUID}-batch-group-free-classes`;
    if (isServer) promises.push(store.dispatch(fetchTopologyInfo(goalUID)));
    if (!state.paginator?.batchGroupFreeClasses?.[key]) {
      promises.push(
        store.dispatch(fetchBatchesGroupTrailClasses(goalUID, false))
      );
    }

    await Promise.all(promises);
    return {
      isServer,
      goalInfo: store.getState().topologies.data[goalUID]
    };
  },
  BatchGroupClasses.pageInfo
);

BatchGroupClasses.propTypes = {
  goalInfo: PropTypes.objectOf(PropTypes.any).isRequired
};

BatchGroupClasses.Layout = Layout;
BatchGroupClasses.Wrapper = PageReduxProvider;
